import { useState } from 'react'
import { FullScreenModal } from '../../utility/FullScreenModal'

export const Confine = () => {
    const [showModal, setShowModal] = useState(false)
    const [modalContent, setModalContent] = useState({ contentType: '', category: '', index: 1 })
    const handleOpenModal = (contentType, category, index, maxIndex) => {
        setModalContent({ contentType, category, index, maxIndex })
        setShowModal(true)
    }
    const handleCloseModal = () => {
        setModalContent({ contentType: '', category: '', index: 0 })
        setShowModal(false)
    }
    return (
        <>
            <section className=''>
                <div className='flex justify-center '>
                    <img
                        className=''
                        alt='confine'
                        src={`${process.env.PUBLIC_URL}/images/system/system-header-confine.png`}
                    />
                </div>
                <div className='text-pbnavy font-kiwi font-bold text-sub md:text-base text-shadow-white w-full md:w-4/5 px-4 md:px-0 mx-auto mt-12'>
                    <p>
                        Thanks to <span className='text-pborange'>Marona's power</span>, allied Phantoms can{' '}
                        <span className='text-pborange'>possess (Confine)</span> objects on the map, like trees and
                        rocks, to participate in battle.
                    </p>
                    <p className='mt-8'>
                        The deployed character's stats will change based on{' '}
                        <span className='text-pborange'>what they're Confined to</span>. For example, if Confined to a
                        rock, their defensive power will increase, but their speed will decrease. If Confined to a
                        weapon, their attack power will increase.
                    </p>{' '}
                    <div className='flex mt-8'>
                        <div className='w-full md:w-3/5 mx-auto'>
                            <img
                                onClick={() => {
                                    handleOpenModal('image', 'confine', 1)
                                }}
                                className='ss-thumb'
                                alt='gameflow button'
                                src={`${process.env.PUBLIC_URL}/images/ss/ss-confine-1-s.webp`}
                            />
                        </div>
                    </div>{' '}
                </div>{' '}
                <div className='flex justify-center mt-12'>
                    <img
                        className=''
                        alt='gameflow button'
                        src={`${process.env.PUBLIC_URL}/images/system/system-header-system.png`}
                    />
                </div>{' '}
                <div className='text-pbnavy font-kiwi font-bold text-sub md:text-base text-shadow-white w-full md:w-4/5 px-4 md:px-0 mx-auto mt-12'>
                    <p>
                        After a few turns, an ally's Confinement will{' '}
                        <span className='text-pborange'>end and the character will be Removed</span>—or withdrawn—from
                        battle. Removed characters cannot be Confined again in the same battle, so think carefully about
                        who you Confine, and when!
                    </p>{' '}
                    <div className='flex mt-8'>
                        <div className='w-4/5 md:w-3/5 mx-auto'>
                            <img
                                onClick={() => {
                                    handleOpenModal('image', 'confine', 2)
                                }}
                                className='ss-thumb'
                                alt='gameflow button'
                                src={`${process.env.PUBLIC_URL}/images/ss/ss-confine-2-s.webp`}
                            />
                            <p className='mt-4 text-pbnavy font-kiwi font-bold text-sub md:text-sm text-shadow-white text-center'>
                                If you choose the wrong time to use Confine, it can put you at a severe disadvantage in
                                battle!{' '}
                            </p>
                        </div>
                    </div>{' '}
                </div>
                <div className='text-pbnavy font-kiwi font-bold text-sub md:text-base text-shadow-white w-full md:w-4/5 px-4 md:px-0 mx-auto mt-12'>
                    <p>
                        You can Confine objects deep behind enemy lines, objects around Marona to keep her safe, and
                        more. The choice of who, what, when, and where to Confine makes this system rich with
                        near-limitless possibilities!
                    </p>
                </div>
                <FullScreenModal
                    showModal={showModal}
                    modalContent={modalContent}
                    setModalImage
                    handleCloseModal={handleCloseModal}
                    setModalContent={setModalContent}
                    maxIndex={2}
                />
            </section>
        </>
    )
}
